import { render, staticRenderFns } from "./orderGzh.vue?vue&type=template&id=cb18a58a&scoped=true"
import script from "./orderGzh.vue?vue&type=script&lang=js"
export * from "./orderGzh.vue?vue&type=script&lang=js"
import style0 from "./orderGzh.vue?vue&type=style&index=0&id=cb18a58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb18a58a",
  null
  
)

export default component.exports